<template>
  <section v-if="works.length" class="dialogue-work-links" aria-labelledby="dialogue-linked-works">
    <h2 id="dialogue-linked-works">{{ zh ? '相關作品' : 'Related works' }}</h2>
    <ul><li v-for="work in works" :key="work.slug"><router-link :to="(zh ? '/zh' : '') + '/work/' + work.slug + '/'">{{ zh ? (work.titleZh || work.title) : work.title }}</router-link></li></ul>
  </section>
</template>
<script setup>
import { computed } from 'vue'
import details from '@/data/work-details.json'
import catalog from '@/data/work-catalog.json'
const props = defineProps({ slug: { type: String, required: true }, zh: Boolean })
const works = computed(() => catalog.filter(work => (details[work.slug]?.links || []).some(link => {
  try {
    const url = new URL(link.url, 'https://cheyuwu.com')
    return url.origin === 'https://cheyuwu.com' && url.pathname.replace(/\/$/, '').replace(/^\/zh(?=\/)/, '') === '/dialogues/' + props.slug
  } catch { return false }
})))
</script>
<style scoped>
.dialogue-work-links { margin-top: 40px; padding-top: 24px; border-top: 1px solid var(--line-2); }
.dialogue-work-links h2 { font-family: var(--font-display); font-size: 1.35rem; margin-bottom: 12px; }
.dialogue-work-links ul { margin: 0; padding-left: 1.2rem; }
.dialogue-work-links a { display: inline-block; min-height: 44px; padding: 10px 0; color: var(--gold); overflow-wrap: anywhere; text-underline-offset: 4px; }
.dialogue-work-links a:focus-visible { outline: 2px solid var(--gold); outline-offset: 3px; }
</style>
